import React, { Component } from 'react'
import { Trans } from '@lingui/macro'
import { ButtonPrimary } from 'front-end/src/components'
import { CreateEventModal } from '../../components/create-event-modal/CreateEventModal'
import { IconPlus } from 'front-end/src/components/common/icon/IconPlus'

interface IState {
  showCreateEventModal: boolean
}

export class CreateEventButton extends Component<
  Record<string, unknown>,
  IState
> {
  state: IState = {
    showCreateEventModal: false
  }

  toggleCreateEventModal = (showCreateEventModal) =>
    this.setState({ showCreateEventModal })

  render() {
    const { showCreateEventModal } = this.state

    return (
      <>
        <CreateEventModal
          show={showCreateEventModal}
          onHide={() => this.toggleCreateEventModal(false)}
        />{' '}
        <ButtonPrimary
          className="CreateEventButton"
          onClick={() => this.toggleCreateEventModal(true)}
          leftIcon={<IconPlus />}
        >
          <Trans>Create a new event</Trans>
        </ButtonPrimary>
      </>
    )
  }
}
